import { render, staticRenderFns } from "./Shares.vue?vue&type=template&id=0c84c434&"
import script from "./Shares.vue?vue&type=script&lang=js&"
export * from "./Shares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports